import { useState } from "react"

export const ReportTrainingState = () => {
    const [genrate, setGenerate] = useState({date_start:'', date_end: '', id: '', status:'all'})
    const [genValidate, setGenValidate] = useState({date_start:false, date_end: false, id: false})
    const [dataList, setDataList] = useState([])
    const [pretestList, setPretestList] = useState({list: [], loading: false, iscroll: true})
    const [quizList, setQuizList] = useState({list: [], loading: false, iscroll: true})
    const [peList, setPEList] = useState({list: [], loading: false, iscroll: true})
    const [peListExport, setPEListExport] = useState([])
    const [isLoading ,setIsLoading] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorID, setAnchorID] = useState(null);
    const [trainingTitle, setTrainingTitle] = useState('');
    const [userTrainList, setUserTrainList] = useState([])

    return {
        trList: {data: dataList, set: setDataList},
        pretestList: {data: pretestList, set: setPretestList},
        quizList: {data: quizList, set: setQuizList},
        peList: {data: peList, set: setPEList},
        peListExport: {data: peListExport, set: setPEListExport},
        trName: {data: trainingTitle, set: setTrainingTitle},
        usertrList: {data: userTrainList, set: setUserTrainList},
        isLoading: {data: isLoading, set: setIsLoading},
        anchorEl: {data: anchorEl, set: setAnchorEl},
        anchorID: {data: anchorID, set: setAnchorID},
        gen: {data: genrate, set: setGenerate},
        genValidate: {data: genValidate, set: setGenValidate},
    }
}

export const ReportCourseState = () => {
    const [genrate, setGenerate] = useState({date_start:'', date_end: '', id: ''})
    const [genValidate, setGenValidate] = useState({date_start:false, date_end: false, id: false})

    return {
        gen: {data: genrate, set: setGenerate},
        genValidate: {data: genValidate, set: setGenValidate},
    }
}